import {ArcElement, Chart as ChartJS, Legend, LinearScale, Tooltip} from "chart.js";
import { Doughnut } from 'react-chartjs-2';
import {Box} from "@chakra-ui/react";

ChartJS.register(
    ArcElement,
    Tooltip,
    Legend,
    LinearScale,
);

export const DoughnutChart = () => {

    const centerTextPlugin = {
        id: "centerText",
        beforeDraw: (chart) => {
            const { width, height, ctx } = chart;
            ctx.restore();

            const fontSize1 = (height / 300).toFixed(2);
            ctx.font = `${fontSize1}em sans-serif`;
            ctx.textBaseline = "middle";
            ctx.textAlign = "center";
            ctx.fillStyle = "#B1B5C3";

            const text = "Total Value";
            const textX = width / 2;
            const textY = height / 2 - 35;
            ctx.fillText(text, textX, textY);

            const fontSize2 = (height / 200).toFixed(2);
            ctx.font = `${fontSize2}em sans-serif`;
            ctx.fillStyle = "#B1B5C3";

            const text2 = "$9,999.99";
            ctx.fillText(text2, textX, textY + 30);

            ctx.save();
        },
    };


    const data = {
        labels: ['Visitors', 'Registered', 'Purchase'],
        datasets: [
            {
                label: '',
                data: [12, 19, 3,],
                backgroundColor: [
                    '#AE59DC',
                    '#3070F5',
                    '#57BEB5',
                ],
                borderColor: [
                    '#FFFFFF',
                    '#FFFFFF',
                    '#FFFFFF',
                ],
                borderWidth: 2,
            },
        ],
    };

    const options = {
        plugins: {
            legend: {
                position: 'bottom',
                labels: {
                    boxWidth: 12,
                    border: 'none',
                    padding: 16,
                    font: {
                        size: 12,
                    },
                    generateLabels: (chart) => {
                        return chart.data.labels.map((label, i) => ({
                            text: label,
                            fillStyle: chart.data.datasets[0].backgroundColor[i],
                            strokeStyle: "transparent",
                            lineWidth: 0,
                        }));
                    },
                },
            },
        },
        cutout: '70%',
        responsive: true,
        maintainAspectRatio: false,
    };

    return (
        <Box
            position={'relative'}
            width="99%"
            height={'306px'}
            maxWidth="100%">
            <Doughnut
                redraw={true}
                data={data}
                plugins={[centerTextPlugin]}
                options={options}/>
        </Box>
    )
}